import React from 'react';
import { BaseRestrictionsEnableControl } from 'src/components/enterprise/features/Corporate/components/Form/common/BaseRestrictionsEnable/BaseRestrictionsEnableControl';

export interface MerchantRestrictionsEnableProps {
  name: string;
  id: string;
}

export function MerchantRestrictionsEnableControl({
  name,
  id,
}: MerchantRestrictionsEnableProps): JSX.Element {
  return (
    <BaseRestrictionsEnableControl
      id={id}
      name={name}
      label="Restrict merchant types"
    />
  );
}
